import React from 'react';

import Main from 'Elements/Main';
import Section from 'Elements/Section';

import Grid, { Col } from 'Components/Grid';
import Breadcrumbs, { BreadcrumbsProps } from 'Components/Breadcrumbs';

import HeroBanner, { HeroMediaHubProps } from 'Modules/HeroBanner/MediaHub';
import MediaHubFilters, { MediaHubFiltersProps } from 'Modules/Filters/MediaHub';
import MediaHubListing, { ListingMediaHubProps } from 'Modules/Listing/MediaHub';

export interface Props {
    breadcrumbs: BreadcrumbsProps;
    heroBanner: HeroMediaHubProps;
    filters: MediaHubFiltersProps;
    listing: ListingMediaHubProps;
}

const Listing: React.FC<Props> = props => {
    const { breadcrumbs, heroBanner, filters, listing } = props;

    return (
        <Main>
            <Breadcrumbs {...breadcrumbs} />
            <HeroBanner {...heroBanner} />
            <MediaHubFilters {...filters} />
            <Section id="listing" background>
                <Grid>
                    <Col>
                        <MediaHubListing {...listing} />
                    </Col>
                </Grid>
            </Section>
        </Main>
    );
};

export default Listing;
